import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';
import { CardElement, injectStripe } from 'react-stripe-elements';
import { Elements } from 'react-stripe-elements';
import Button from '@material-ui/core/Button';


const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  textFieldLabel: {
    // color: "red",
    textAlign: "center",
    fontFamily: [
      'Open Sans',
      'sans-serif'

    ].join(','),
  },
  textField: {
    // marginLeft: theme.spacing.unit,
    // marginRight: theme.spacing.unit,
    // // width: 50,

    color: "#203b60",
    textAlign: "center",

    fontFamily: [
      'Open Sans',
      'sans-serif'

    ].join(','),
  },
  MtextField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    // width: 50,

    color: "#203b60",
    fontSize: "18px",
    textAlign: "center",

    fontFamily: [
      'Open Sans',
      'sans-serif'

    ].join(','),
  },
  dense: {
    marginTop: 19,
  },
  menu: {
    width: 200,
  },
  paperRoot: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    marginBottom: '15px',
    width: '100%',

  },
  paperImp: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    marginTop: '15px'
    // width:'100%'
  },
  group: {
    margin: `${theme.spacing.unit}px 0`,
    flexDirection: 'row'
  },
  root: {
    padding: 0,
    marginBottom: '1px'



  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    // margin: theme.spacing.unit,
    // boxShadow: 'none',
    textTransform: 'none',
    fontSize: 16,
    width:'100%',
    // fontWeight:'800',
    padding: '3px 6px',
    border: '1px solid',
    color: 'white',
    // lineHeight: 1.5,
    backgroundColor:'rgb(37,106,167)',
    borderColor:'rgb(37,106,167)',
    fontFamily: [
      'Open Sans',
      'sans-serif'

    ].join(','),
    '&:hover': {
      backgroundColor: '#203b60',
      borderColor: '#203b60',
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: '#0062cc',
      borderColor: '#005cbf',
    },
  },
  buttonBack: {
    // margin: theme.spacing.unit,
    // boxShadow: 'none',
    textTransform: 'none',
    fontSize: 16,
    // fontWeight:'800',
    padding: '3px 6px',
    width:'100%',
    // border: '1px solid',
    color: '#203b60',
    // lineHeight: 1.5,
    backgroundColor: '#f2f2f2',
    // borderColor: 'rgb(114, 165,199)',
    fontFamily: [
      'Open Sans',
      'sans-serif'

    ].join(','),
    // '&:hover': {
    //   backgroundColor: '#203b60',
    //   borderColor: '#203b60',
    // },
    // '&:active': {
    //   boxShadow: 'none',
    //   backgroundColor: '#0062cc',
    //   borderColor: '#005cbf',
    // },
  },
  commonMargin:{
    marginTop:theme.spacing.unit *2,
    marginBottom:theme.spacing.unit*2
  }

});

class PaymentForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      token: "",
      name:""
    }
    this.createToken = this.createToken.bind(this);
    this.handleName= this.handleName.bind(this);
    // this.handleNext = this.handleName.bind(this);
  }

  handleName(e){
    this.setState({
      name:e.target.value
    })
  }

  handleBack = () => {
    this.props.back()

    // this.setState(state => ({
    //   activeStep: state.activeStep - 1,
    // }));


  };

 

  async createToken() {
    console.log("Ingreso a create token")
    let { token } = await this.props.stripe.createToken({ name:this.state.name, address_line1:this.props.form_info.address_line1, address_zip:this.props.form_info.address_zip, address_city:this.props.form_info.address_city, address_country:this.props.form_info.address_country.code });
    console.log("token in create token")
    console.log(token)
    await this.props.nextStep(token)
    
  }

  


  render() {
    const { classes } = this.props;
    return (

      <Grid>
        {/* <p>Would you like to complete the purchase?</p> */}
        <Grid item xs={12} >
          <TextField
            required
            id="name"
            name="name"
            label="Nombre como figura en la tarjeta"
            fullWidth
            onChange={this.handleName}
            // autoComplete="fname"
            InputProps={{
              classes: {
                root: classes.textField,
                input: { textAlign: 'center' }
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.textFieldLabel,
              },
            }}
          />
        </Grid>
        <Grid style={{marginTop:"20px"}} item sm={6} >

          <CardElement />
        </Grid>

        <Grid className={classes.commonMargin} direction='row' alignItems='flex-end' justify='space-between' container spacing={40}>
                <Grid item xs={12} sm={4}>
                  <Button onClick={this.handleBack} variant="contained" className={classes.buttonBack}>
                    <i style={{ marginRight: "8px" }} className="fa fa-1x fa-chevron-left"></i>
                    Volver
                  </Button>
                </Grid>

                <Grid  item xs={12} sm={4}>

                  <Button  onClick={this.createToken} variant="contained" className={classes.button}>
                    Siguiente
                    <i style={{ marginLeft: "8px" }} className="fa fa-1x fa-chevron-right"></i>
                  </Button>

                </Grid>
              </Grid>

        
        {/* <div className={classes.buttons}>

        <Button onClick={this.createToken} variant="contained" className={classes.button}>
                      Siguiente
                <i style={{ marginLeft: "8px" }} className="fa fa-1x fa-chevron-right"></i>
                    </Button>

        </div> */}
       
        {/* <button onClick={this.createToken}>Tokenize</button> */}
      </Grid >

    )
  }
}


export default withStyles(styles)(injectStripe(PaymentForm))
